import { render, staticRenderFns } from "./LoaderDualRing.component.vue?vue&type=template&id=285c4b98&scoped=true&"
import script from "./LoaderDualRing.component.vue?vue&type=script&lang=ts&"
export * from "./LoaderDualRing.component.vue?vue&type=script&lang=ts&"
import style0 from "./LoaderDualRing.component.vue?vue&type=style&index=0&id=285c4b98&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285c4b98",
  null
  
)

export default component.exports